import responsiveCallback from "./responsiveCallback";

$( window ).resize(function() {
  responsiveCallback(768, isMobile => {
    if (isMobile) {
      $('.m-go-maps-overlay').height($('.m-go-maps-overlay__flyout').outerHeight() + 32);
    } else {
      $('.m-go-maps-overlay').height('auto');
    }
  });
});
